import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogDeleteGenericComponent } from '@app/shared/components/dialog-delete-generic/dialog-delete-generic.component';
import { NotificationType } from '@app/shared/interfaces';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { PropertiesService } from '@app/shared/services/properties/properties.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { map } from 'rxjs/operators';
import { DialogWidgetPreviewComponent } from '../../components/dialog-widget-preview/dialog-widget-preview.component';
import {
  DirectService,
  DirectWidget,
  DirectWidgetCreateRequest,
  DirectWidgetStatus,
} from '../../services/direct.service';

@Component({
  standalone: false,
  templateUrl: './direct-widget-add.component.html',
  styleUrls: ['./direct-widget-add.component.scss'],
})
export class DirectWidgetAddComponent implements OnInit {
  DirectWidgetStatus = DirectWidgetStatus;
  loading: boolean;
  error: boolean;

  isMobile$ = this.deviceDetectionService.isMobileViewport();

  properties: any[] = [];

  widget: DirectWidgetCreateRequest | DirectWidget;

  templates$ = this.direct.getSiteTemplates();
  saving: boolean;
  disabling: boolean;
  recentlySaved: boolean;

  previewPropertyId: number;

  constructor(
    private propertiesService: PropertiesService,
    private direct: DirectService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router,
    private deviceDetectionService: DeviceDetectionService,
    private toast: ToastNotificationsService
  ) { }

  ngOnInit(): void {
    this.getProperties();
    this.loading = true;

    this.route.paramMap.subscribe((params) => {
      if (params.has('id')) {
        this.direct
          .getWidgets()
          .pipe(
            map((widgets) => {
              return widgets.find((widget) => widget.uuid === params.get('id'));
            })
          )
          .subscribe((widget) => {
            this.widget = widget;
            this.loading = false;
          });
      }
    });
  }

  getProperties() {
    this.propertiesService.getDirectProperties().subscribe((res) => {
      this.properties = res;

      this.previewPropertyId = this.properties[0].id;
    });
  }

  updateProperties(event: { all_properties: boolean; properties: number[] }) {
    this.widget.all_properties = event.all_properties;
    this.widget.properties = event.properties;
  }

  saveWidget() {
    if (this.doWeHaveBlockedProperties()) {
      return;
    }

    this.saving = true;

    this.direct.updateWidget((this.widget as DirectWidget).uuid, this.widget).subscribe(
      (res) => {
        this.saving = false;
        this.justSaved();
      },
      (err) => {
        this.saving = false;
      }
    );
  }

  doWeHaveBlockedProperties(): boolean {
    let blockFound = false;

    this.widget.properties.forEach((propId) => {
      const property = this.properties.find((prop) => prop.id === propId);

      let checks = property.checks.filter((check) => check.id !== 'google_vacation_rentals');

      if (checks.some((check) => check.result === 'block')) {
        this.toast.open(
          'You cannot save this site with the selected properties. Please resolve issues with the properties and try again.',
          'Dismiss',
          NotificationType.Error
        );
        blockFound = true;
      }
    });

    return blockFound;
  }

  previewWidget(theme: string) {
    this.dialog.open(DialogWidgetPreviewComponent, {
      width: '400px',
      maxHeight: '90vh',
      height: '90vh',
      data: {
        theme,
        propertyId: this.properties[0].id,
        properties: this.properties,
      },
    });
  }

  justSaved() {
    this.recentlySaved = true;

    if (this.disabling) {
      this.disabling = false;
    }
    setTimeout(() => {
      this.recentlySaved = false;
    }, 2000);
  }

  deleteWidgetPrompt() {
    const dialogRef = this.dialog.open(DialogDeleteGenericComponent, {
      width: '720px',
      data: {
        name: 'this Booking Widget',
        additionalText: 'Any existing bookings that were made using this widget will not be impacted.',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteWidget();
      }
    });
  }

  deleteWidget() {
    this.direct.deleteWidget((this.widget as DirectWidget).uuid).subscribe((res) => {
      this.router.navigate(['/direct']);
    });
  }
}
